import { useEffect, useState } from "react";
import { navLinks, tickerItems } from "@/mocks/home";

function Ticker() {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const t = setInterval(() => {
      setIdx((p) => (p + 1) % tickerItems.length);
    }, 4200);
    return () => clearInterval(t);
  }, []);
  return (
    <div className="bg-accent-950 text-background-50">
      <div className="mx-auto flex max-w-7xl items-center gap-3 px-4 py-2 md:px-6">
        <span className="flex shrink-0 items-center gap-1.5 rounded-full bg-primary-500 px-2.5 py-0.5 text-xs font-bold whitespace-nowrap">
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-background-50/70"></span>
            <span className="relative inline-flex h-2 w-2 rounded-full bg-background-50"></span>
          </span>
          全网热度
        </span>
        <p key={idx} className="animate-[fadeIn_0.5s_ease] truncate text-sm text-background-100">
          {tickerItems[idx]}
        </p>
        <span className="ml-auto hidden shrink-0 text-xs text-accent-300 sm:block whitespace-nowrap">每 5 分钟自动刷新</span>
      </div>
    </div>
  );
}

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id: string) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header className="sticky top-0 z-50">
      <Ticker />
      <nav
        className={`border-b transition-all duration-300 ${
          scrolled ? "border-background-200 bg-background-50/90 shadow-none backdrop-blur-md" : "border-background-200/60 bg-background-50"
        }`}
      >
        <div className="mx-auto flex h-16 max-w-7xl items-center gap-6 px-4 md:px-6">
          <button type="button" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
              <i className="ri-fire-fill text-lg"></i>
            </span>
            <span className="font-heading text-2xl font-bold tracking-tight text-accent-900">
              吃瓜<span className="text-primary-600">17</span>
            </span>
          </button>

          <div className="ml-auto hidden items-center gap-1 md:flex">
            {navLinks.map((n) => (
              <button
                key={n.id}
                type="button"
                onClick={() => go(n.id)}
                className="rounded-md px-3.5 py-2 text-sm font-medium text-foreground-700 whitespace-nowrap transition-colors hover:bg-secondary-100 hover:text-foreground-950"
              >
                {n.label}
              </button>
            ))}
          </div>

          <div className="ml-auto flex items-center gap-3 md:ml-0">
            <button
              type="button"
              onClick={() => go("report")}
              className="hidden items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2 text-sm font-bold whitespace-nowrap text-background-50 transition-colors hover:bg-primary-600 sm:flex"
            >
              <i className="ri-upload-cloud-2-line text-base"></i>
              投稿爆料
            </button>
            <button
              type="button"
              aria-label="菜单"
              onClick={() => setOpen((v) => !v)}
              className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 text-foreground-800 md:hidden"
            >
              <i className={`text-lg ${open ? "ri-close-line" : "ri-menu-line"}`}></i>
            </button>
          </div>
        </div>

        {open && (
          <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
            <div className="flex flex-col gap-1">
              {navLinks.map((n) => (
                <button
                  key={n.id}
                  type="button"
                  onClick={() => go(n.id)}
                  className="flex items-center justify-between rounded-md px-3 py-2.5 text-left text-sm font-medium text-foreground-800 hover:bg-secondary-100"
                >
                  {n.label}
                  <i className="ri-arrow-right-s-line text-secondary-500"></i>
                </button>
              ))}
              <button
                type="button"
                onClick={() => go("report")}
                className="mt-1 flex items-center justify-center gap-1.5 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-bold whitespace-nowrap text-background-50"
              >
                <i className="ri-upload-cloud-2-line text-base"></i>
                投稿爆料
              </button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}